import type { CategoryWithShows } from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { ShowWithPrice, UiCategoryWithShows } from '~/shared/interfaces'
import type {
  CurrentTvShowWithPriceFormatted,
  FormatCurrentShowParams,
} from './index.h'

import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const formatCategoryWithShowsToUi = (
  data: CategoryWithShows | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithShows | null => {
  if (!data) return null

  const formattedContent = data.content.map((tvShow) =>
    extendMediaItemByLabelPrice(adjust(tvShow))
  ) as ShowWithPrice[]

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}

export const formatCurrentShow = ({
  current,
  t,
}: FormatCurrentShowParams): CurrentTvShowWithPriceFormatted | null => {
  if (!current) return null
  const count = current.episodeCount || 0

  return {
    ...(extendMediaItemByLabelPrice(current) as ShowWithPrice),
    currentEpisodesCount: t('episode_count', { count }),
    // WBS sends i18n keys, not copy — the bundle owns the wording.
    contentLabels: (current?.labels ?? []).map((key) => t(key)),
  }
}

export const formatSeasonCountLabel = (
  seasonCount: number | null | undefined,
  t: TFunction
): string => (seasonCount ? t('season_count', { count: seasonCount }) : '')

// WBS resolves the Series > Season > Episode priority server-side and sends a
// single i18n key, not copy — the bundle owns the wording. PIN-lock (AC-8) is
// enforced on the card (`!locked`), not here; geoblock does not hide the badge.
export const resolveShowNewLabel = (
  { labels }: { labels?: string[] },
  t: TFunction
): string | undefined => (labels?.[0] ? t(labels[0]) : undefined)
